import React from 'react';
import "../loader.css"

export default function LoadingPage() {
  return (
    <div class="loader-container">
      <div class="loader"></div>
       </div>
  );
}
